import { Component, signal, Input, effect, inject, ViewChild, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { GenericListComponent } from '@app/common-codes/components/list-components/generic-base-list/generic-list.component';
import { Register } from '@app/common-codes/decorators/DependencyInjectionRegistreyDecorators';
import { ListTableColumnComponent } from '@app/common-codes/components/list-components/list-table-column/list-table-column.component';
import { ListViewComponent } from '@app/common-codes/components/list-components/list-view/list-view.component';
import { MatwinsSkins } from '@app/common-codes/skins/global.skin';
import { AlertModalService } from '@app/common-codes/services/AlertModalService';
import { IStaticStylesConfig } from '@app/common-codes/skins/_primitives/IStaticStylesConfig';
import { TranslationService } from '@app/common-codes/services/TranslationService';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';
import { TruckerActivity } from '@app/common-codes/models/matwins-tenant/TruckerActivity.model';
import { IEntityMetaData } from '@app/common-codes/_models/IEntityMetaData';
import { LookupProfile, LookupService, LookupItem } from '@app/common-codes/services/LookupService';
import { IListType } from '@app/common-codes/components/_primitives/IListType';
import { GenetricDetailComponent } from '@app/common-codes/components/edit-components/generic-detail.component';
import { TruckerActivityDetailComponent } from '../../../matwins-tenant/trucker-activity/activity-detail/trucker-activity-detail.component';


@Register(TruckerActivity)
@Component({
  selector: 'app-trucker-activity-stack-list',
  standalone: true,
  imports: [
    ListViewComponent,
    ListTableColumnComponent,
    TranslatePipe
],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './trucker-activity-stack-list.component.html'
})
export class TruckerActivityStackListComponent extends GenericListComponent<TruckerActivity> {
  @Input() showCreateButton: boolean = false;

  @Input() override nestedData: TruckerActivity[] = []; 
  @Output() activitySelected = new EventEmitter<TruckerActivity>(); // 
  @Output() itemSaved = new EventEmitter<TruckerActivity>(); // Add itemSaved output

  override Skin = MatwinsSkins.QrCode1 as IStaticStylesConfig;
  override ComponentEntityClass = TruckerActivity;

  override entityMetaData: IEntityMetaData = new TruckerActivity().GetType();
  override contextMenuItems = []; // 
  public ListType = IListType;
  @ViewChild('truckerActivityDetail', { read: TruckerActivityDetailComponent }) detail!: TruckerActivityDetailComponent;

  activityStatusLookup = signal<LookupItem[]>([]);

  public static override get lookupProfiles(): LookupProfile[] {
    const lookupProfiles: LookupProfile[] = [
      //{
      //  lookupName: "Dock"
      //},
      //{
      //  lookupName: "ActivityStatus"
      //},
      //{
      //  lookupName: "ActivityDeliveryType"
      //},
    ];
    return lookupProfiles;
  }

  constructor(
    _alertModalService: AlertModalService,
    translationService: TranslationService,
  ) {
    super();
    this.alertModalService = _alertModalService;

    effect(() => {
      const entities = this.listView()?.entities();
      if (entities) {
        // Lire la revision : si les listes arrivent en retard, l'effet repasse et les remplit.
        this.lookupService.revision();
        this.activityStatusLookup.set(this.lookupService.getLookupData('ActivityStatus'));
      }
    });

  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  override getdetailComponent(): GenetricDetailComponent<TruckerActivity> | undefined {
    return this.detail;
  }

  override  selectSingleItem(id: any) {
    super.selectSingleItem(id);

    this.editSelectedItem(this.selectedItem()); 
  }

  override editSelectedItem(selectedItem: TruckerActivity | null) {
    if (selectedItem) {
      super.editSelectedItem(selectedItem);
      this.activitySelected.emit(selectedItem);
    }
  }

  //handleEntitySelected(item: any) {
  //  if (item) {
  //    console.log("Selected ", item); 
  //  }
  //}


  handleItemSaved(event: TruckerActivity) {
    this.onItemUpdated(event); 
    this.itemSaved.emit(event); 
    this.closeModal(true); 
  }

  override closeModal(refresh?: boolean): void {
    super.closeModal(refresh ?? false); 
    if (refresh) {
      this.refreshList();
    }
  }
}
